module.exports = __webpack_public_path__ + "static/media/MIFA.b9e0717e.jpg";